export const isaQuestions = [
  {
    left: 'ct-library.isa.questions.1.left',
    right: 'ct-library.isa.questions.1.right',
  },
  {
    left: 'ct-library.isa.questions.2.left',
    right: 'ct-library.isa.questions.2.right',
  },
  {
    left: 'ct-library.isa.questions.3.left',
    right: 'ct-library.isa.questions.3.right',
  },
  {
    left: 'ct-library.isa.questions.4.left',
    right: 'ct-library.isa.questions.4.right',
  },
  {
    left: 'ct-library.isa.questions.5.left',
    right: 'ct-library.isa.questions.5.right',
  },
  {
    left: 'ct-library.isa.questions.6.left',
    right: 'ct-library.isa.questions.6.right',
  },
  {
    left: 'ct-library.isa.questions.7.left',
    right: 'ct-library.isa.questions.7.right',
  },
  {
    left: 'ct-library.isa.questions.8.left',
    right: 'ct-library.isa.questions.8.right',
  },
  {
    left: 'ct-library.isa.questions.9.left',
    right: 'ct-library.isa.questions.9.right',
  },
  {
    left: 'ct-library.isa.questions.10.left',
    right: 'ct-library.isa.questions.10.right',
  },
  {
    left: 'ct-library.isa.questions.11.left',
    right: 'ct-library.isa.questions.11.right',
  },
  {
    left: 'ct-library.isa.questions.12.left',
    right: 'ct-library.isa.questions.12.right',
  },
  {
    left: 'ct-library.isa.questions.13.left',
    right: 'ct-library.isa.questions.13.right',
  },
  {
    left: 'ct-library.isa.questions.14.left',
    right: 'ct-library.isa.questions.14.right',
  },
  {
    left: 'ct-library.isa.questions.15.left',
    right: 'ct-library.isa.questions.15.right',
  },
  {
    left: 'ct-library.isa.questions.16.left',
    right: 'ct-library.isa.questions.16.right',
  },
  {
    left: 'ct-library.isa.questions.17.left',
    right: 'ct-library.isa.questions.17.right',
  },
  {
    left: 'ct-library.isa.questions.18.left',
    right: 'ct-library.isa.questions.18.right',
  },
  {
    left: 'ct-library.isa.questions.19.left',
    right: 'ct-library.isa.questions.19.right',
  },
  {
    left: 'ct-library.isa.questions.20.left',
    right: 'ct-library.isa.questions.20.right',
  },
  {
    left: 'ct-library.isa.questions.21.left',
    right: 'ct-library.isa.questions.21.right',
  },
  {
    left: 'ct-library.isa.questions.22.left',
    right: 'ct-library.isa.questions.22.right',
  },
  {
    left: 'ct-library.isa.questions.23.left',
    right: 'ct-library.isa.questions.23.right',
  },
  {
    left: 'ct-library.isa.questions.24.left',
    right: 'ct-library.isa.questions.24.right',
  },
  {
    left: 'ct-library.isa.questions.25.left',
    right: 'ct-library.isa.questions.25.right',
  },
  {
    left: 'ct-library.isa.questions.26.left',
    right: 'ct-library.isa.questions.26.right',
  },
  {
    left: 'ct-library.isa.questions.27.left',
    right: 'ct-library.isa.questions.27.right',
  },
  {
    left: 'ct-library.isa.questions.28.left',
    right: 'ct-library.isa.questions.28.right',
  },
];
